import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Google Analytics Measurement ID
const GA_MEASUREMENT_ID = "G-C38SDSBS23";

/**
 * Tracks SPA route changes and sends a page_view to Google Analytics
 * on every navigation. The base gtag.js snippet is loaded in public/index.html.
 */
const GAPageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") {
      return;
    }

    const pagePath = location.pathname + location.search;

    window.gtag("config", GA_MEASUREMENT_ID, {
      page_path: pagePath,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
};

export default GAPageTracker;
